import { render, staticRenderFns } from "./OrderComponentVip.vue?vue&type=template&id=b31d9e74&"
import script from "./OrderComponentVip.vue?vue&type=script&lang=js&"
export * from "./OrderComponentVip.vue?vue&type=script&lang=js&"
import style0 from "./OrderComponentVip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports